module.exports = __webpack_public_path__ + "img/IMG_20180706_125630.02fb7f28.jpg";